export default __webpack_public_path__ + "static/media/nothing-here.0a93bd71.png";